import { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Divider, Button } from '@mui/material';
import { Subtitle } from '../forms/Title';
import StaticWeekPicker from '../forms/StaticWeekPicker';
import InnerLayout from '../../styles/InnerLayout';
import { UseStores } from '../../hooks/UseStores';
import { scrollToSection } from '../../utils/abdmUtils';
import useMediaQuery from '@mui/material/useMediaQuery';

const DeliveryDateSection = () => {
  const { audience, store } = UseStores();
  const [availability, setAvailability] = useState(null);
  const [selectedDates, setSelectedDates] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const collisionPoint = useMediaQuery('(max-width:1360px)');
  const lgValue = collisionPoint ? 9 : 7.5;
  useEffect(() => {
    if (!audience.selectedAudience.label) return;
    setAvailability(audience.availability);
    setSelectedDates(audience.availability[0]);
  }, [audience.selectedAudience.label]);

  useEffect(() => {
    if (selectedDates) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
      return;
    }
    store.setSelectedAvailability(selectedDates);
  }, [selectedDates]);

  const styles = {
    innerLayout: {
      marginTop: '60px',
      paddingBottom: '100px',
    },
  };

  return (
    <Grid
      container
      rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
      columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
      id="delivery-date"
    >
      <Grid item xs={12} sx={styles.innerLayout}>
        <InnerLayout>
          <Subtitle title="Delivery date" />
          <Divider />
          <Typography variant="body1" gutterBottom>
            Select the week you want your postcards delivered.
          </Typography>
          <Grid item xs={12} lg={lgValue}>
            <StaticWeekPicker
              selectedDates={selectedDates}
              availableDates={availability}
              onChange={setSelectedDates}
            />
          </Grid>
          <Divider />
          <Button
            disableElevation
            data-testid="confirmDateButton"
            variant="contained"
            disabled={isDisabled}
            color={isDisabled ? 'secondary' : 'primary'}
            size="large"
            endIcon={<ChevronRightIcon />}
            onClick={isDisabled ? null : () => scrollToSection('order-summary')}
          >
            Confirm date
          </Button>
        </InnerLayout>
      </Grid>
    </Grid>
  );
};

export default observer(DeliveryDateSection);
